(() => {
  const boot = window.ydsHeadingRevealBoot;
  if (!boot?.enabled || window.ydsCollectionHeadingReveal) return;
  window.ydsCollectionHeadingReveal = true;
  const selector = '.yds-olivia-launch h2,.yds-flox-launch--home .yds-flox-launch__copy h2,.yds-illustrated-feature h2,.yds-fit__copy h2,.yds-home82__commercial-copy h2,.yds-home82__quiet-copy h2,.yds-home82__making-copy h2';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet(), pending = new Set(), running = new Set();
  let observer;
  const revealAll = () => {
    boot.fallback();
    clearTimeout(boot.timer);
    observer?.disconnect();
    pending.clear();
    running.forEach(animation => animation.cancel());
    running.clear();
  };
  try {
    if (motion.matches) { revealAll(); return; }
    observer = new IntersectionObserver(entries => {
      try {
        for (const entry of entries) {
          if (!entry.isIntersecting || entry.intersectionRatio < .1) continue;
          const heading = entry.target;
          observer.unobserve(heading);
          pending.delete(heading);
          if (seen.has(heading)) continue;
          seen.add(heading);
          heading.setAttribute('data-yds-heading-revealed', '');
          if (!boot.enabled || motion.matches) continue;
          const animation = heading.animate([
            { opacity: 0, transform: 'translateX(-20px)', color: '#666666' },
            { opacity: 1, transform: 'translateX(0)', color: '#000000' }
          ], { duration: 2720, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
          running.add(animation);
          const clear = () => running.delete(animation);
          animation.onfinish = clear;
          animation.oncancel = clear;
        }
      } catch (_) { revealAll(); }
    }, { rootMargin: '0px 0px -8% 0px', threshold: .1 });
    const scan = (root = document) => {
      if (!boot.enabled) return;
      try {
        root.querySelectorAll(selector).forEach(heading => {
          if (seen.has(heading) || pending.has(heading) || heading.hasAttribute('data-yds-heading-revealed')) return;
          pending.add(heading);
          observer.observe(heading);
        });
      } catch (_) { revealAll(); }
    };
    motion.addEventListener('change', () => { if (motion.matches) revealAll(); });
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      pending.forEach(heading => {
        if (event.target.contains(heading)) { observer.unobserve(heading); pending.delete(heading); }
      });
    });
    scan();
    clearTimeout(boot.timer);
  } catch (_) { revealAll(); }
})();
